import { render, staticRenderFns } from "./ForwardDialog.vue?vue&type=template&id=7dfd4881&scoped=true"
import script from "./ForwardDialog.vue?vue&type=script&lang=js"
export * from "./ForwardDialog.vue?vue&type=script&lang=js"
import style0 from "./ForwardDialog.vue?vue&type=style&index=0&id=7dfd4881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd4881",
  null
  
)

export default component.exports